import React from 'react';
import Navbar from '../../Components/Layout/Navbar';
import Footer from '../../Components/Layout/Footer';

const NonAuthLayout = ({ children }) => {
  return (
    <React.Fragment>
      <Navbar />
      <main className="pt-16 md:pt-[104px]">
        {children}
      </main>
      <Footer />
    </React.Fragment>
  );
};

export default NonAuthLayout;
